import { useStore } from '@/utils/vue-api';
import { computed } from 'vue';

export function useModuleAttrs() {
	const isCustomM = module => {
		const { type } = module;
		return type === 1;
	};
	const isDisplayM = module => {
		const { type } = module;
		return type === 2;
	};
	const isTextImageM = module => {
		return isDisplayM(module) && module.exhibitionType === 2;
	};

	const getModuleId = module => {
		const { moduleId } = module;
		if (isCustomM(module)) return 'custom';
		if (isDisplayM(module)) return 'widget_shell';
		return moduleId;
	};

	const getModuleProps = module => {
		const { moduleId, contentText, column = 100, name } = module;
		if (isCustomM(module)) return { moduleId, name };
		if (isDisplayM(module)) return { data: contentText, moduleId, name, moduleData: module };
		return { column, moduleId, name };
	};

	const getModuleKey = module => {
		const { _key, moduleId } = module;
		return _key || moduleId;
	};

	const store = useStore();
	const getAllModules = computed(() => store.getters.getPageAllModules);
	const searchModuleIdWithParams = moduleId => {
		const hasNumber = /\d/.test(moduleId);
		if (!hasNumber) return moduleId;

		const allModules = getAllModules.value;
		const activeModule = allModules.find(m => m.moduleId === moduleId);
		return getModuleId(activeModule || {});
	};

	return {
		isCustomM,
		isDisplayM,
		isTextImageM,

		getModuleId,
		getModuleProps,
		getModuleKey,
		searchModuleIdWithParams
	};
}
